import { useLazyQuery } from 'components/graphql'
import { Modal } from 'components/Modal'
import ViewerPDF from 'components/ViewerPDF'
import React, { useMemo, useState } from 'react'
import getBillPdf from 'sections/closing/gql/getBillPdf'

export const useModalBillPdf = () => {
	const [pdfsLoading, setPdfsLoading] = useState({})
	const [closeModal, setCloseModal] = useState(false)
	const [pdfUrl, setPdfUrl] = useState('')

	const tooglePdfsLoading = (billNumber, value = false) => {
		setPdfsLoading((prevPdfsLoading) => ({
			...prevPdfsLoading,
			[billNumber]: value
		}))
	}

	const [getBillPdfUrl, { queryField: billPdfQueryField, variables: vars }] = useLazyQuery(getBillPdf, {
		onCompleted: res => {
			const url = res?.cashAssist?.[billPdfQueryField]?.url
			tooglePdfsLoading(vars?.billNumber)
			if(url) {
				setPdfUrl(url)
				setCloseModal((prev) => !prev)
			}
		},
		onError: () => tooglePdfsLoading(vars?.billNumber)
	})

	const handlePdfClick = ({ billNumber, cashRegisterId }) => e => {
		if(billNumber && cashRegisterId) {
			e.stopPropagation()
			tooglePdfsLoading(billNumber, true)
			getBillPdfUrl({
				variables: { billNumber, cashRegisterId }
			})
		}
	}

	const ModalComponent = useMemo(() => (
		<Modal unmount={() => setCloseModal(false)} fullScreen={true}>
			<ViewerPDF src={pdfUrl} style={{ height: '100%' }} />
		</Modal>
	), [pdfUrl])

	return {
		handlePdfClick,
		pdfsLoading,
		closeModal,
		ModalComponent
	}
}
